import { render } from "./Chapter.vue?vue&type=template&id=48937cf4&scoped=true&ts=true"
import script from "./Chapter.vue?vue&type=script&lang=ts"
export * from "./Chapter.vue?vue&type=script&lang=ts"

import "./Chapter.vue?vue&type=style&index=0&id=48937cf4&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48937cf4"]])

export default __exports__